/** drapp menu key → Persian title of the native page */
export const NATIVE_PANEL_TITLES = {
  vacation: 'مرخصی',
  workhours: 'ساعت کاری',
  service: 'تعرفه‌ها',
  appointments: 'مراجعین من',
  setting: 'تنظیمات نوبت‌دهی',
} as const;

export type NativePanelKey = keyof typeof NATIVE_PANEL_TITLES;

/** Route of each native page (the doctor home pushes these instead of opening the providers iframe). */
export const nativePanelHref = (key: NativePanelKey, query?: Record<string, string | undefined>) => {
  const params = new URLSearchParams();
  Object.entries(query ?? {}).forEach(([name, value]) => value && params.set(name, value));
  const qs = params.toString();
  return `/dashboard/apps/drapp/${key}/${qs ? `?${qs}` : ''}`;
};
